// Dependencies
import { ThemeProvider } from 'styled-components';

// Contexts
import MinicartProvider from '../contexts/Minicart';

// Components
import CartHeader from '../components/CartHeader';
import CartSidebar from '../components/CartSidebar';

// Hooks
import { useWindowResize } from '../hooks';

const Minicart = ({loading, errors, data: {notices, ...data}, ...props}: any) => {

	useWindowResize(true); // NOTE: Multiple apps may provide this

	return (
		<ThemeProvider theme={props.theme}>
			<MinicartProvider {...{...props, data, loading, config: {...props.config, notices: {...props.config.notices, ...notices}}}}>
				<CartHeader className="wooptima-cart-header" icon="ico-cart-default" />
				{props.config.general.minicartEnabled && <CartSidebar className="wooptima-minicart-sidebar"/> }
			</MinicartProvider>
		</ThemeProvider>
	)

}

export default Minicart;
